import {BaseCachedService} from './Core/BaseCachedService';

class SpeciesRequestStatusService extends BaseCachedService {
    get Url() { return super.Url + "/speciesRequestStatus"; }
    get ModelName() { return "Species Request Status"; }
    get PrimaryKeyProperty() { return "speciesRequestStatusId"; }
    get TitleProperty() { return "name"; }
}

export const service = new SpeciesRequestStatusService();

